import React, { useState, useEffect, useContext } from 'react';
import { withRouter } from 'react-router-dom';
import _ from 'lodash';
import { connect } from 'react-redux';
import Modal from 'modules/common/components/Modal';
import useFormValidator from 'useFormValidator';

import PropTypes from 'prop-types';
import { ModalContext } from 'App';
import * as actions from '../../../action';
import * as c from '../../../constant';

import { InputTemplate } from "../../../../../common/components/inputComponents";

function CreateModal({
  updateMiscFeeSettingsOffice,
  showMiscFeeSettingsOffice,
  getMiscFeeSettingsOfficeList,
  updateList,
  history,
  getRoleList,
  creating,
  id,
}) {
  const setModal = useContext(ModalContext);
  const [formData, setFormData] = useState(() => {
    if (updateList) {
      return {
        name: String(_.get(updateList, "name")),
        code: _.get(updateList, "code"),
        description: _.get(updateList, "description"),
      }
    }
    return c.FORMS_OFFICE
  })

  const validateForm = useFormValidator(formData, { name: 'required', });

  useEffect(() => {
    validateForm.validate();
  }, [Object.values(formData).join(',')]);

  useEffect(() => {
    getRoleList();
    getMiscFeeSettingsOfficeList(c.IS_ACTIVE)
  }, []);

  const handleOnSubmit = (e) => {
    e.preventDefault();

    const args = {
      ...formData,
      ...c.IS_ACTIVE,
      name: _.toUpper(formData.name),
      code: _.toUpper(formData.code),
    }

    // UPDATE
    updateMiscFeeSettingsOffice(id, args, () => {
      setModal({ isOpen: false });
      getMiscFeeSettingsOfficeList(c.IS_ACTIVE);
      history.push(`/miscellaneous-fees/settings/office/${id}`);
      showMiscFeeSettingsOffice(id);
    });
  };

  const onChange = e => {
    return setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };

  const closeModal = (e) => {
    e.preventDefault();
    setModal({ isOpen: false });
  };

  return (
    <Modal.Body>
      <form onSubmit={handleOnSubmit}>
        <div className="full-group-v2">
          <div className="form-row">
            <InputTemplate
              title="Name"
              htmlFor="name"
              containerClassName="col-12"
              formValidatorMsg={validateForm.renderMessage("name")}
              // Input component props
              placeholder=""
              className="full-input-v2 text-uppercase"
              id="name"
              name="name"
              type="text"
              onChange={onChange}
              value={_.get(formData, 'name') || ''}
            />
            <InputTemplate
              title="Code"
              htmlFor="code"
              containerClassName="col-12"
              // Input component props
              placeholder=""
              className="full-input-v2 text-uppercase"
              id="code"
              name="code"
              type="text"
              onChange={onChange}
              value={_.get(formData, 'code') || ''}
            />
            <InputTemplate
              title="Description"
              htmlFor="description"
              containerClassName="col-12"
              withCustomInputComponent={() => (
                <textarea
                  className="full-input-v2 w-100"
                  type="text"
                  rows="3"
                  autoComplete="none"
                  name="description"
                  id="description"
                  onChange={onChange}
                  value={_.get(formData, 'description') || ''}
                  placeholder=""
                  spellCheck="false"
                  required
                />
              )} 
            />
          </div>
        </div>
        <div className="d-flex justify-content-center">
          <button
            disabled={creating}
            type="submit"
            className="mt-3 btn btn-primary cms-bg-color-primary cms-outline-primary  mr-3"
          >
            <span className="font-weight-bold">
              {creating ? <i className="fa fa-spin fa-spinner" /> : `Submit`}
            </span>
          </button>
          <button
            disabled={creating}
            type="button"
            onClick={closeModal}
            className="mt-3 btn btn-dark "
          >
            <span className="font-weight-bold">Cancel</span>
          </button>
        </div>
      </form>
    </Modal.Body>
  );
}

CreateModal.propTypes = {
  showMiscFeeSettingsOffice: PropTypes.instanceOf(Function).isRequired,
  getMiscFeeSettingsOfficeList: PropTypes.instanceOf(Function).isRequired,
  updateMiscFeeSettingsOffice: PropTypes.instanceOf(Function).isRequired,
  history: PropTypes.instanceOf(Object).isRequired,
  getRoleList: PropTypes.instanceOf(Function).isRequired,
  updateList: PropTypes.instanceOf(Object).isRequired,
  creating: PropTypes.bool.isRequired,
  id: PropTypes.string.isRequired,
};

const mapStateToProps = ({ api }) => ({
  roleList: _.get(api, `${c.GET_ROLE_LIST}.list`) || [],
  creating: api.loading.indexOf(c.UPDATE_MISC_FEE_SETTINGS_OFFICE) > -1,
});

const enhance = _.flowRight([
  withRouter,
  connect(mapStateToProps, {
    ...actions,
  }),
]);

export default enhance(CreateModal);
